import React from 'react';
import './CompanyIntro.css';
import CustomLink2 from '../CustomLink/CustomLink2';

const CompanyIntro = ({ title, details, links }) => {
  return (
    <div className="company-intro-container">
      <h1 className="company-intro-title">{title}</h1>
      <p className="company-intro-details">{details}</p>
      <div className="company-intro-cards">
        {links.map((link, index) => (
          <div key={index} className="company-intro-card">
            <img src={link.image} alt={link.name} className="company-intro-image" />
            <div className="company-intro-card-content">
              <h3 className="company-intro-card-title">{link.name}</h3>
              <p className="company-intro-card-details">{link.details}</p>
              <CustomLink2 link={link.url} linktext={link.button}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyIntro;
